import { getType } from 'typesafe-actions'

import { googleApiInitialized } from '../actions/dependencies'

const initialState = {
  googleApi: false,
}

export type DependenciesState = typeof initialState

export default (state: DependenciesState = initialState, action: any) => {
  switch (action.type) {
    case getType(googleApiInitialized):
      return {
        googleApi: true,
        ...state,
      }
    default:
      return state
  }
}
